import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Redirect, withRouter } from "react-router-dom";
import { PATHS, STATUS } from "../../constant";
import { userLoginRequest, userSecurityKey } from "../../actions/login.action";
import { getLocalstorage } from "../../helper";
import { Form, Button } from "react-bootstrap";
import cookieService from "../../services/cookieService";
import { LoaderPage } from "../../component/Loader";
import { DEFAULT_VALIDATION } from "../../validation";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "../../customToast";

class UserVerification extends Component {
  constructor(props) {
    super(props);
    const loginFormData = cookieService.getCookie(
      this.props.cookies,
      "loginFormUserInfo"
    );
    this.state = {
      username: (loginFormData && loginFormData.username) || "",
      errors: {},
      submitBtnText: "Enter Password",
      redirectToReferrer: !!getLocalstorage("token"),
      data: {}
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  validateField = (fieldName, value) => {
    let { errors, username } = this.state;
    if (fieldName === "username") {
      errors.usernameValid = DEFAULT_VALIDATION(value, "Username");
    } else {
      errors.usernameValid = DEFAULT_VALIDATION(username, "Username");
    }
    this.setState({
      errors: errors
    });
  };

  validateForm = () => {
    let { errors } = this.state;
    let { usernameValid } = errors;
    return usernameValid.error !== undefined && !usernameValid.error;
  };

  submitLoginRequest = async loginType => {
    const { username } = this.state;
    const { userLoginRequest } = this.props;

    const payload = {
      loginType: loginType,
      userId: username
    };

    this.validateField();
    let isValidData = this.validateForm();
    if (isValidData) {
      try {
        await userLoginRequest(payload);
        const { loginRequestData, history } = this.props;
        if (loginRequestData && loginRequestData.status) {
          history.push(
            loginType === "PASSWORD"
              ? PATHS.LOGIN_WITH_PASSWORD
              : PATHS.LOGIN_WITH_OTP
          );
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {loginRequestData && loginRequestData.message}
            </p>,
            errorToastStyle
          );
          history.push(PATHS.LOGIN);
        }
      } catch (e) {
        console.log(`Error in login ${e.message}`);
      }
    }
  };

  render() {
    const { username, errors, submitBtnText, redirectToReferrer } = this.state;
    const { location, loading } = this.props;
    const { from } = location.state || { from: { pathname: PATHS.DASHBOARD } };
    if (redirectToReferrer) return <Redirect to={from} />;
    return (
      <div className="register-inner">
        <LoaderPage loading={loading === STATUS.LOADING} />
        <h1 className="page-heading hide-heading">User Verification</h1>
        <Form className="signin-form">
          <Form.Group controlId="username">
            <Form.Label data-test="username-label">
              User ID / Email / Mobile No.
            </Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={username}
              onChange={this.handleChange}
              onBlur={() => this.validateField("username", username)}
              isInvalid={errors.usernameValid && errors.usernameValid.error}
            />
            <Form.Control.Feedback type="invalid">
              {errors.usernameValid && errors.usernameValid.error
                ? errors.usernameValid.message
                : null}
            </Form.Control.Feedback>
          </Form.Group>
          <div className="user-verify-btns">
            <Button
              variant="primary"
              className="btn-orange-invert full-width"
              data-test="enter-password-button"
              onClick={() => this.submitLoginRequest("PASSWORD")}
            >
              {submitBtnText}
            </Button>
            <Button
              variant="primary"
              className="btn-orange-invert full-width"
              data-test="get-otp-button"
              onClick={() => this.submitLoginRequest("OTP")}
            >
              Get OTP
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

UserVerification.propTypes = {
  history: PropTypes.shape({}),
  location: PropTypes.shape({})
};

UserVerification.defaultProps = {
  history: {},
  location: {}
};

function mapStateToProps(state) {
  return {
    loginRequestData: state.loginReducer.loginRequestData,
    loading: state.loginReducer.loginRequestStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userSecurityKey,
      userLoginRequest
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserVerification)
);
